import { useEffect, useState } from "react";
import datetimeProvider from "../../providers/datetime.provider";

export default function CountdownClock({
    startingMinutes = 0,
    startingSeconds = 0,
    onFinish = () => { },
}) {

    const moment = datetimeProvider.momentInstance();

    const [timer, setTimer] = useState({
        minutes: startingMinutes,
        seconds: startingSeconds,
    });

    useEffect(() => {
        const countdownDuration = moment.duration(startingMinutes, 'minutes');

        const interval = setInterval(() => {
            countdownDuration.subtract(1, 'second');

            setTimer({
                minutes: countdownDuration.minutes(),
                seconds: countdownDuration.seconds(),
            });

            if (countdownDuration.asSeconds() <= 0) {
                clearInterval(interval);
                onFinish();
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const renderTimeDigit = (digit = 0) => (
        <div
            className="w-[56px] lg:w-[72px] h-16 lg:h-24 flex justify-center items-center rounded-xl bg-primary text-white text-5xl lg:text-7xl font-bold"
            style={{ backgroundImage: 'linear-gradient(transparent 50%, #ffffff12 50%)' }}
        >
            <div
                className="bg-clip-text text-transparent"
                style={{ backgroundImage: 'linear-gradient(#fff 50%, #eee 50%)' }}
            >
                {digit}
            </div>
        </div>
    );

    const getDigits = (num) => {
        return num.toString().padStart(2, '0').split('');
    };

    return (
        <div className="flex gap-6">
            <div>
                <div className="flex gap-1">
                    {renderTimeDigit(getDigits(timer.minutes)[0])}
                    {renderTimeDigit(getDigits(timer.minutes)[1])}
                </div>
                <div className="mt-2 text-center">
                    Minutos
                </div>
            </div>
            <div>
                <div className="flex gap-1">
                    {renderTimeDigit(getDigits(timer.seconds)[0])}
                    {renderTimeDigit(getDigits(timer.seconds)[1])}
                </div>
                <div className="mt-2 text-center">
                    Segundos
                </div>
            </div>
        </div>
    );
}